export const scrollSection = (args) => {
  const { swiperRef, position, direction, scrollAmount } = args;
  let scrollPos = swiperRef.scrollLeft;

  if (position) {
    scrollPos = position;
  } else if (direction === 'right') {
    scrollPos += scrollAmount;
  } else {
    scrollPos -= scrollAmount;
  }

  const offset = parseInt(
    window.getComputedStyle(swiperRef, null).getPropertyValue('padding-left'),
    10
  );
  if (offset) {
    scrollPos -= offset;
  }

  swiperRef.scrollTo({
    left: scrollPos,
    behavior: 'smooth',
  });
};

export const checkSelectedOffsets = (args) => {
  const { swiperType, swiperRef, alignToLeft = false, componentClass = '' } = args;

  setTimeout(() => {
    const swiper = swiperRef;
    const componentSelector = componentClass ? `.${componentClass}` : '';
    const selected = document.querySelector(`${componentSelector} .${swiperType}-swiper .selected`);

    const selectedLeftOffset =
      selected !== null ? selected.offsetLeft + selected.closest('.range').offsetLeft : 0;
    const selectedRightOffset =
      selected !== null ? swiper.offsetWidth - (selectedLeftOffset + selected.offsetWidth) : 0;

    if (selectedLeftOffset < 0 || alignToLeft) {
      const scrollParamsLeft = { ...args, position: selectedLeftOffset };

      scrollSection(scrollParamsLeft);
    } else if (selectedRightOffset < 0) {
      const scrollParamsRight = { ...args, position: -selectedRightOffset };

      scrollSection(scrollParamsRight);
    }
  }, 500);
};

export const getCurrentMonthOnScroll = (calendarSwipeRef, navLeftBtnRef) => {
  const navLeftbtnPosition = navLeftBtnRef.getBoundingClientRect().left + navLeftBtnRef.offsetWidth;

  const monthWrapsOnLeft = Array.from(
    calendarSwipeRef.querySelectorAll('.date-swiper .month-display')
  ).filter((monthWrap) => monthWrap.getBoundingClientRect().left <= navLeftbtnPosition);

  return monthWrapsOnLeft.length ? monthWrapsOnLeft.pop().id : '';
};
